import DesignChooserActions from "../actions/DesignChooserActions";
import SiteSettingsActions from "../actions/SiteSettingsActions";
import UIActions from "../actions/UIActions";
import AppConstants from "../constants/AppConstants";

const {
  ASSET_LIBRARY_MODE_VIEW,
  MAIN_VIEW_USER_SITE_CHOOSER,
  USER_SITES_VIEW_MODE_MANAGE,
  MAIN_VIEW_LIBRARY_SITE_CHOOSER,
  MODAL_DESIGN_IMPORT,
  MODAL_DOMAIN_SETUP,
  MODAL_USER_EXPORTS,
  USER_SITES_VIEW_MODE_SELECT,
} = AppConstants;

export const showSiteDesignChooserModal = () => {
  UIActions.showAppView({
    view: MAIN_VIEW_USER_SITE_CHOOSER,
    allowBack: true,
    props: { mode: USER_SITES_VIEW_MODE_MANAGE },
  });
};

export const showNewDesignModal = () => {
  UIActions.showAppView({ view: MAIN_VIEW_LIBRARY_SITE_CHOOSER, allowBack: true });
};

export const showSharedDesignModal = () => {
  UIActions.modalOpen(MODAL_USER_EXPORTS);
};

export const showDesignImportModal = () => {
  UIActions.modalOpen(MODAL_DESIGN_IMPORT);
};

export const showAdminRestoreModal = () => {
  DesignChooserActions.openDialog({
    showTabs: false,
    restoreMode: true,
  });
};

export const showDemoSiteChooser = () => {
  UIActions.showAppView({
    view: MAIN_VIEW_USER_SITE_CHOOSER,
    allowBack: false,
    props: { mode: USER_SITES_VIEW_MODE_SELECT },
  });
};

export const showSignupModal = () => {
  UIActions.openSignupModal();
};

export const showSiteSettingsModal = () => {
  SiteSettingsActions.openDialog();
};

export const showDesignSettingsModal = () => {
  UIActions.showTheme();
};

export const showDomainSetupModal = () => {
  UIActions.modalOpen(MODAL_DOMAIN_SETUP, {
    onHide: () => UIActions.modalClose(MODAL_DOMAIN_SETUP),
  });
};

export const showMediaLibraryModal = () => {
  const config = {
    title: "Manage Assets",
    mode: ASSET_LIBRARY_MODE_VIEW,
  };

  UIActions.toggleAssetChooser(config);
};
